/*
Government Purpose Rights (“GPR”)
Contract No.  W911NF-14-D-0005
Contractor Name:   University of Southern California
Contractor Address:  3720 S. Flower Street, 3rd Floor, Los Angeles, CA 90089-0001
Expiration Date:  Restrictions do not expire, GPR is perpetual
Restrictions Notice/Marking: The Government's rights to use, modify, reproduce, release, perform, display, or disclose this software are restricted by paragraph (b)(2) of the Rights in Noncommercial Computer Software and Noncommercial Computer Software Documentation clause contained in the above identified contract.  No restrictions apply after the expiration date shown above. Any reproduction of the software or portions thereof marked with this legend must also reproduce the markings. (see: DFARS 252.227-7014(f)(2)) 
No Commercial Use: This software shall be used for government purposes only and shall not, without the express written permission of the party whose name appears in the restrictive legend, be used, modified, reproduced, released, performed, or displayed for any commercial purpose or disclosed to a person other than subcontractors, suppliers, or prospective subcontractors or suppliers, who require the software to submit offers for, or perform, government contracts.  Prior to disclosing the software, the Contractor shall require the persons to whom disclosure will be made to complete and sign the non-disclosure agreement at 227.7103-7.  (see DFARS 252.227-7025(b)(2))
*/
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  Character,
  Characters,
} from "@ictlearningsciences/pal3-core/character";
import { LessonLearningMode } from "@ictlearningsciences/pal3-core/types";

/** Store */
export enum AudioMode {
  VOICE_ONLY = "Voice only",
  TTS_ONLY = "TTS only",
  BOTH = "Both (Default to voice)",
}
export interface SettingsState {
  character: Character;
  audioMode: AudioMode;
  volume: number;
  voiceTTS?: string;
  voiceRecorded?: string;
  showPassiveScore: boolean;
  learningMode: LessonLearningMode;
}

const initialState: SettingsState = {
  character: Characters[0],
  audioMode: AudioMode.VOICE_ONLY,
  volume: 1,
  voiceTTS: undefined,
  voiceRecorded: undefined,
  showPassiveScore: true,
  learningMode: LessonLearningMode.GUIDED,
};

/** Actions */
export const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    resetSettings: (state) => {
      state.character = initialState.character;
      state.audioMode = initialState.audioMode;
      state.volume = initialState.volume;
      state.voiceTTS = initialState.voiceTTS;
      state.voiceRecorded = initialState.voiceRecorded;
      state.showPassiveScore = initialState.showPassiveScore;
      state.learningMode = initialState.learningMode;
    },
    updateSettings: (state, action: PayloadAction<Partial<SettingsState>>) => {
      const newState = { ...state, ...action.payload };
      state.character = newState.character;
      state.audioMode = newState.audioMode;
      state.volume = newState.volume;
      state.voiceTTS = newState.voiceTTS;
      state.voiceRecorded = newState.voiceRecorded;
      state.showPassiveScore = newState.showPassiveScore;
      state.learningMode = newState.learningMode;
    },
  },
});

export const { resetSettings, updateSettings } = settingsSlice.actions;
export default settingsSlice.reducer;
